import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconViewExplore = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.5 4.5V15.5H9V4.5H10.5ZM9 3C8.17188 3 7.5 3.67188 7.5 4.5V15.5C7.5 16.3281 8.17188 17 9 17H10.5C11.3281 17 12 16.3281 12 15.5V4.5C12 3.67188 11.3281 3 10.5 3H9ZM4.5 10.5V15.5H3V10.5H4.5ZM3 9C2.17188 9 1.5 9.67188 1.5 10.5V15.5C1.5 16.3281 2.17188 17 3 17H4.5C5.32812 17 6 16.3281 6 15.5V10.5C6 9.67188 5.32812 9 4.5 9H3ZM15 6.5H16.5V15.5H15V6.5ZM13.5 6.5V15.5C13.5 16.3281 14.1719 17 15 17H16.5C17.3281 17 18 16.3281 18 15.5V6.5C18 5.67188 17.3281 5 16.5 5H15C14.1719 5 13.5 5.67188 13.5 6.5Z",
		fill: "currentColor"
	})
});
export default SvgIconViewExplore;
